/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AssetComponentResponseDto,
  CreateAssetComponentRequestDto,
  ListAssetComponentContextsResponseDto,
  ListAssetComponentsResponseDto,
  UpdateAssetComponentRequestDto,
} from '../models/index';
import {
    AssetComponentResponseDtoFromJSON,
    AssetComponentResponseDtoToJSON,
    CreateAssetComponentRequestDtoFromJSON,
    CreateAssetComponentRequestDtoToJSON,
    ListAssetComponentContextsResponseDtoFromJSON,
    ListAssetComponentContextsResponseDtoToJSON,
    ListAssetComponentsResponseDtoFromJSON,
    ListAssetComponentsResponseDtoToJSON,
    UpdateAssetComponentRequestDtoFromJSON,
    UpdateAssetComponentRequestDtoToJSON,
} from '../models/index';

export interface AssetComponentControllerCreateRequest {
    assetId: string;
    organizationId: string;
    createAssetComponentRequestDto: CreateAssetComponentRequestDto;
}

export interface AssetComponentControllerDeleteRequest {
    componentId: string;
    assetId: string;
    organizationId: string;
}

export interface AssetComponentControllerGetByIdRequest {
    componentId: string;
    assetId: string;
    organizationId: string;
}

export interface AssetComponentControllerListRequest {
    limit: number;
    page: number;
    assetId: string;
    organizationId: string;
    q?: string;
}

export interface AssetComponentControllerListContextsRequest {
    assetId: string;
    organizationId: string;
}

export interface AssetComponentControllerUpdateRequest {
    componentId: string;
    assetId: string;
    organizationId: string;
    updateAssetComponentRequestDto: UpdateAssetComponentRequestDto;
}

/**
 * 
 */
export class AssetComponentsApi extends runtime.BaseAPI {

    /**
     */
    async assetComponentControllerCreateRaw(requestParameters: AssetComponentControllerCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AssetComponentResponseDto>> {
        if (requestParameters['assetId'] == null) {
            throw new runtime.RequiredError(
                'assetId',
                'Required parameter "assetId" was null or undefined when calling assetComponentControllerCreate().'
            );
        }

        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling assetComponentControllerCreate().'
            );
        }

        if (requestParameters['createAssetComponentRequestDto'] == null) {
            throw new runtime.RequiredError(
                'createAssetComponentRequestDto',
                'Required parameter "createAssetComponentRequestDto" was null or undefined when calling assetComponentControllerCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/organizations/{organizationId}/assets/{assetId}/components`;
        urlPath = urlPath.replace(`{${"assetId"}}`, encodeURIComponent(String(requestParameters['assetId'])));
        urlPath = urlPath.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters['organizationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateAssetComponentRequestDtoToJSON(requestParameters['createAssetComponentRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AssetComponentResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async assetComponentControllerCreate(requestParameters: AssetComponentControllerCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AssetComponentResponseDto> {
        const response = await this.assetComponentControllerCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async assetComponentControllerDeleteRaw(requestParameters: AssetComponentControllerDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['componentId'] == null) {
            throw new runtime.RequiredError(
                'componentId',
                'Required parameter "componentId" was null or undefined when calling assetComponentControllerDelete().'
            );
        }

        if (requestParameters['assetId'] == null) {
            throw new runtime.RequiredError(
                'assetId',
                'Required parameter "assetId" was null or undefined when calling assetComponentControllerDelete().'
            );
        }

        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling assetComponentControllerDelete().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/organizations/{organizationId}/assets/{assetId}/components/{componentId}`;
        urlPath = urlPath.replace(`{${"componentId"}}`, encodeURIComponent(String(requestParameters['componentId'])));
        urlPath = urlPath.replace(`{${"assetId"}}`, encodeURIComponent(String(requestParameters['assetId'])));
        urlPath = urlPath.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters['organizationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async assetComponentControllerDelete(requestParameters: AssetComponentControllerDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.assetComponentControllerDeleteRaw(requestParameters, initOverrides);
    }

    /**
     */
    async assetComponentControllerGetByIdRaw(requestParameters: AssetComponentControllerGetByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AssetComponentResponseDto>> {
        if (requestParameters['componentId'] == null) {
            throw new runtime.RequiredError(
                'componentId',
                'Required parameter "componentId" was null or undefined when calling assetComponentControllerGetById().'
            );
        }

        if (requestParameters['assetId'] == null) {
            throw new runtime.RequiredError(
                'assetId',
                'Required parameter "assetId" was null or undefined when calling assetComponentControllerGetById().'
            );
        }

        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling assetComponentControllerGetById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/organizations/{organizationId}/assets/{assetId}/components/{componentId}`;
        urlPath = urlPath.replace(`{${"componentId"}}`, encodeURIComponent(String(requestParameters['componentId'])));
        urlPath = urlPath.replace(`{${"assetId"}}`, encodeURIComponent(String(requestParameters['assetId'])));
        urlPath = urlPath.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters['organizationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AssetComponentResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async assetComponentControllerGetById(requestParameters: AssetComponentControllerGetByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AssetComponentResponseDto> {
        const response = await this.assetComponentControllerGetByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async assetComponentControllerListRaw(requestParameters: AssetComponentControllerListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListAssetComponentsResponseDto>> {
        if (requestParameters['limit'] == null) {
            throw new runtime.RequiredError(
                'limit',
                'Required parameter "limit" was null or undefined when calling assetComponentControllerList().'
            );
        }

        if (requestParameters['page'] == null) {
            throw new runtime.RequiredError(
                'page',
                'Required parameter "page" was null or undefined when calling assetComponentControllerList().'
            );
        }

        if (requestParameters['assetId'] == null) {
            throw new runtime.RequiredError(
                'assetId',
                'Required parameter "assetId" was null or undefined when calling assetComponentControllerList().'
            );
        }

        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling assetComponentControllerList().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['q'] != null) {
            queryParameters['q'] = requestParameters['q'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/organizations/{organizationId}/assets/{assetId}/components`;
        urlPath = urlPath.replace(`{${"assetId"}}`, encodeURIComponent(String(requestParameters['assetId'])));
        urlPath = urlPath.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters['organizationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListAssetComponentsResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async assetComponentControllerList(requestParameters: AssetComponentControllerListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListAssetComponentsResponseDto> {
        const response = await this.assetComponentControllerListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async assetComponentControllerListContextsRaw(requestParameters: AssetComponentControllerListContextsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListAssetComponentContextsResponseDto>> {
        if (requestParameters['assetId'] == null) {
            throw new runtime.RequiredError(
                'assetId',
                'Required parameter "assetId" was null or undefined when calling assetComponentControllerListContexts().'
            );
        }

        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling assetComponentControllerListContexts().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/organizations/{organizationId}/assets/{assetId}/components/contexts`;
        urlPath = urlPath.replace(`{${"assetId"}}`, encodeURIComponent(String(requestParameters['assetId'])));
        urlPath = urlPath.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters['organizationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListAssetComponentContextsResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async assetComponentControllerListContexts(requestParameters: AssetComponentControllerListContextsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListAssetComponentContextsResponseDto> {
        const response = await this.assetComponentControllerListContextsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async assetComponentControllerUpdateRaw(requestParameters: AssetComponentControllerUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AssetComponentResponseDto>> {
        if (requestParameters['componentId'] == null) {
            throw new runtime.RequiredError(
                'componentId',
                'Required parameter "componentId" was null or undefined when calling assetComponentControllerUpdate().'
            );
        }

        if (requestParameters['assetId'] == null) {
            throw new runtime.RequiredError(
                'assetId',
                'Required parameter "assetId" was null or undefined when calling assetComponentControllerUpdate().'
            );
        }

        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling assetComponentControllerUpdate().'
            );
        }

        if (requestParameters['updateAssetComponentRequestDto'] == null) {
            throw new runtime.RequiredError(
                'updateAssetComponentRequestDto',
                'Required parameter "updateAssetComponentRequestDto" was null or undefined when calling assetComponentControllerUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/organizations/{organizationId}/assets/{assetId}/components/{componentId}`;
        urlPath = urlPath.replace(`{${"componentId"}}`, encodeURIComponent(String(requestParameters['componentId'])));
        urlPath = urlPath.replace(`{${"assetId"}}`, encodeURIComponent(String(requestParameters['assetId'])));
        urlPath = urlPath.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters['organizationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateAssetComponentRequestDtoToJSON(requestParameters['updateAssetComponentRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AssetComponentResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async assetComponentControllerUpdate(requestParameters: AssetComponentControllerUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AssetComponentResponseDto> {
        const response = await this.assetComponentControllerUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
